// @flow
import React from 'react';
import './style.less';

type TProps = {
    bottom?: boolean,
    className?: string,
    dark?: boolean,
    left?: boolean,
    right?: boolean,
    top?: boolean,
};

function Nail({className, dark, top, right, left, bottom}: TProps) {
    let fullClassName = 'nail';

    if (className) {
        fullClassName += ` ${className}`;
    }

    if (dark) {
        fullClassName += ' nail_dark';
    }

    if (top) {
        fullClassName += ' top';
    }

    if (left) {
        fullClassName += ' left';
    }

    if (right) {
        fullClassName += ' right';
    }

    if (bottom) {
        fullClassName += ' bottom';
    }

    return <div className={fullClassName} />;
}

export {Nail};
